import { getAuthentication } from '@/hooks/useAuthentication';
import OnBoardingContainer from '../../../components/on-boarding';
import { onInitOnBoarding } from '../../../services/on-boarding/onboarding.service';
import { useCallback, useEffect } from 'react';
import { useOnBoardingV5 } from '../hooks/useOnBoardingV5';
import { OnBoardingPage } from '@edwin-group/cj-graphql';

export default function OnBoardingStep1() {
  const { page, currentStep, completeStep } = useOnBoardingV5(1);

  const onInit = useCallback(async () => {
    const { user } = getAuthentication();
    if (!user?.id) return;
    await onInitOnBoarding(user.id);
  }, []);

  useEffect(() => {
    onInit();
  }, [onInit]);

  return (
    <OnBoardingContainer
      page={page as OnBoardingPage}
      image={currentStep?.content?.image?.url || ''}
      step={0}
      title={currentStep?.content?.title || ''}
      description={currentStep?.content?.description || ''}
      button={{
        text: currentStep?.content?.button?.text || '',
        onClick: () => completeStep(),
      }}
    />
  );
}
